import React, { useState, useEffect, useRef } from "react";
import "../../../../style/cancelordersearch.css";
import VectorMap from "../../../DentistHub/components/VectorMap";
import DataTable from "react-data-table-component";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Modal } from "react-bootstrap";
import { apiAxios } from "../../../../utils/apiAxios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const AddDeliverypartner: React.FC = () => {

  const [showMap, setShowMap] = useState(false);
  const [loading, setLoading] = useState(false);
  const [partners, setPartners] = useState<any[]>([]);
  const [editId, setEditId] = useState<number | null>(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState<number | null>(null);
  const mapRef = useRef<HTMLDivElement | null>(null);
  const [fullName, setFullName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [alternateMobileNumber, setAlternateMobileNumber] = useState("");
  const [emailID, setEmailID] = useState("");
  const [passwordHash, setPasswordHash] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showPasswordTooltip, setShowPasswordTooltip] = useState(false);
  const [aadharNumber, setAadharNumber] = useState("");
  const [address, setAddress] = useState("");
  const [pincode, setPincode] = useState("");

  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [digiPin, setDigiPin] = useState("");

  const [vehicleType, setVehicleType] = useState("");
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [drivingLicenseNumber, setDrivingLicenseNumber] = useState("");

  const roleID = "7";
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^()_\-+=])[A-Za-z\d@$!%*?&#^()_\-+=]{8,14}$/;

  const columns = [
    { name: "Name", selector: (row: any) => row.name, sortable: true },
    { name: "Mobile", selector: (row: any) => row.mobileNo },
    { name: "Vehicle", selector: (row: any) => row.vehicleType },
    { name: "Vehicle Number", selector: (row: any) => row.vehicleNumber },
    { name: "License", selector: (row: any) => row.drivingLicenseNumber },
    { name: "Pincode", selector: (row: any) => row.pincode },

    {
      name: "Action",
      cell: (row: any) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <button

            onClick={() => handleEdit(row)}
            title="Edit"
          >
            <i className="bi bi-pencil-square customdelete-icon"></i>
          </button>

          <button
            className="action-btn delete"
            onClick={() => confirmDelete(row.userID)}
            title="Delete"
          >
            <i className="bi bi-trash customdelete-icon"></i>
          </button>
        </div>
      )
    }
  ];

  const fetchDeliveryPartners = async () => {
    try {
      const res = await apiAxios.get(`${API_BASE}/DeliveryPartner/GetDeliveryUsers`);
      setPartners(
        (res.data.singleData || []).sort((a: any, b: any) => b.userID - a.userID)
      );
    } catch {
      toast.error("Failed to load delivery partners");
    }
  };

  useEffect(() => {
    fetchDeliveryPartners();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      setLoading(true);
      const basePayload: any = {
        Name: fullName,
        MobileNo: mobileNumber,
        AlternateMobileNumber: alternateMobileNumber,
        Email: emailID,
        RoleID: roleID,
        AadharNumber: aadharNumber,
        Address: address,
        Pincode: pincode,
        Latitude: latitude,
        Longitude: longitude,
        DigiPin: digiPin,
        VehicleType: vehicleType,
        VehicleNumber: vehicleNumber,
        DrivingLicenseNumber: drivingLicenseNumber
      };

      if (editId) {

        const updatePayload = {
          ...basePayload,
          UserID: editId,
        };

        if (passwordHash && confirmPassword) {
          updatePayload.PasswordHash = passwordHash;
          updatePayload.ConfirmPassword = confirmPassword;
        }

        await apiAxios.put(
          `${API_BASE}/Users/UpdateUser/${editId}`,
          updatePayload
        );

        toast.success("Delivery Partner Updated Successfully!");

      }
      else {

        const createPayload = {
          ...basePayload,
          PasswordHash: passwordHash,
          ConfirmPassword: confirmPassword
        };

        await apiAxios.post(
          `${API_BASE}/Users/CreateUser`,
          createPayload
        );

        toast.success("Delivery Partner Added Successfully!");
      }

      fetchDeliveryPartners();
      resetForm();

    } catch (error: any) {
      toast.error(error.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };
  const validateForm = () => {

    if (!/^[6-9]\d{9}$/.test(mobileNumber)) {
      toast.error("Enter valid 10 digit mobile number");
      return false;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailID)) {
      toast.error("Email ID format is not correct");
      return false;
    }

    if (!/^\d{12}$/.test(aadharNumber)) {
      toast.error("Aadhar number must be 12 digits");
      return false;
    }

    if (!/^\d{6}$/.test(pincode)) {
      toast.error("Enter valid 6 digit pincode");
      return false;
    }

    if (vehicleType !== "Cycle") {
      if (!/^[A-Z]{2}[0-9]{2}[A-Z]{1,2}[0-9]{4}$/i.test(vehicleNumber)) {
        toast.error("Enter valid vehicle number (Example: DL01AB1234)");
        return false;
      }
    }

    if (vehicleType !== "Cycle") {
      if (!/^[A-Z]{2}[- ]?\d{2}[- ]?\d{11}$/.test(drivingLicenseNumber)) {
        toast.error("Enter valid driving license number");
        return false;
      }
    }


    if (!passwordRegex.test(passwordHash)) {
      toast.error(
        "Password must have at least one digit, one lowercase, one uppercase, one special character. 8–14 characters. No spaces"
      );
      return false;
    }


    if (passwordHash !== confirmPassword) {
      toast.error("Passwords do not match");
      return false;
    }

    return true;
  };

  const resetForm = () => {

    setFullName("");
    setMobileNumber("");
    setAlternateMobileNumber("");
    setEmailID("");
    setPasswordHash("");
    setConfirmPassword("");
    setAadharNumber("");
    setAddress("");
    setPincode("");
    setLatitude("");
    setLongitude("");
    setDigiPin("");
    setVehicleType("");
    setVehicleNumber("");
    setDrivingLicenseNumber("");
    setEditId(null);

  };

  const confirmDelete = (id: number) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const handleDelete = async () => {

    if (deleteId === null) return;

    try {

      var res = await apiAxios.delete(`${API_BASE}/DeliveryPartner/DeleteUser/${deleteId}`);

      if (res.data.isSuccess) {
        toast.success("Delivery Partner Deleted");
        fetchDeliveryPartners();
      }
      else {
        toast.warning(res.data.status);
      }
    } catch {

      toast.error("Failed to delete delivery partner");

    } finally {

      setShowDeleteModal(false);
      setDeleteId(null);

    }

  };

  const handleEdit = (row: any) => {

    setEditId(row.userID);

    setFullName(row.name || "");
    setMobileNumber(row.mobileNo || "");
    setAlternateMobileNumber(row.alternateMobileNumber || "");
    setEmailID(row.email || "");
    setAadharNumber(row.aadharNumber || "");
    setAddress(row.address || "");
    setPincode(row.pincode || "");
    setLatitude(row.latitude || "");
    setLongitude(row.longitude || "");
    setDigiPin(row.digiPin || "");
    setVehicleType(row.vehicleType || "");
    setVehicleNumber(row.vehicleNumber || "");
    setDrivingLicenseNumber(row.drivingLicenseNumber || "");

    window.scrollTo({ top: 0, behavior: "smooth" });

  };

  return (

    <div className="page-wrapper pb-5 mt-3">

      <h4 className="mb-4">Add Delivery Partner</h4>

      {/* FORM */}
      <div className="premium-card mb-4">


        <form onSubmit={handleSubmit}>

          <div className="row">

            <div className="col-md-4 mb-3">
              <label className="form-label">Full Name<span className="required">*</span></label>
              <input
                className="form-control"
                placeholder="Enter full name"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                required
              />
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">Mobile Number<span className="required">*</span></label>
              <input
                className="form-control"
                placeholder="Enter mobile number"
                value={mobileNumber}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  if (value.length <= 10) {
                    setMobileNumber(value);
                  }
                }}
                maxLength={10}
                required
              />
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">Alternate Mobile</label>
              <input
                className="form-control"
                placeholder="Enter alternate mobile number"
                value={alternateMobileNumber}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  if (value.length <= 10) {
                    setAlternateMobileNumber(value);
                  }
                }}
                maxLength={10}
              />
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">Email<span className="required">*</span></label>
              <input
                type="email"
                className="form-control"
                placeholder="Enter email address"
                value={emailID}
                onChange={(e) => setEmailID(e.target.value)}
                required
              />
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">Password<span className="required">*</span></label>
              <div className="password-field2">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  placeholder="Enter password"
                  value={passwordHash}
                  onChange={(e) => setPasswordHash(e.target.value)}
                  required
                />

                <i
                  className={`bi ${showPassword ? "bi-eye" : "bi-eye-slash"} toggle-icon`}
                  onClick={() => setShowPassword(!showPassword)}
                ></i>
              </div>
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">Confirm Password<span className="required">*</span></label>
              <div className="password-field2">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  className="form-control"
                  placeholder="Confirm password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />

                <i
                  className={`bi ${showConfirmPassword ? "bi-eye" : "bi-eye-slash"} toggle-icon`}
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                ></i>
              </div>
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">Aadhar Number<span className="required">*</span></label>
              <input
                className="form-control"
                placeholder="Enter 12 digit Aadhar number"
                value={aadharNumber}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  if (value.length <= 12) {
                    setAadharNumber(value);
                  }
                }}
                maxLength={12}
              />
            </div>



            <div className="col-md-4 mb-3">
              <label className="form-label">Address<span className="required">*</span></label>
              <textarea
                className="form-control"
                placeholder="Enter address"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">Latitude</label>
              <input
                className="form-control"
                placeholder="Latitude will appear after map selection"
                value={latitude}
                readOnly
              />
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">Longitude</label>
              <input
                className="form-control"
                placeholder="Longitude will appear after map selection"
                value={longitude}
                readOnly
              />
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">Pincode<span className="required">*</span></label>
              <input
                className="form-control"
                placeholder="Enter pincode"
                value={pincode}
                onChange={(e) => setPincode(e.target.value)}
              />
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">Vehicle Type<span className="required">*</span></label>
              <select
                className="form-control"
                value={vehicleType}
                onChange={(e) => setVehicleType(e.target.value)}
              >
                <option value="">Select Vehicle Type</option>
                <option value="Bike">Bike</option>
                <option value="Cycle">Cycle</option>
                <option value="Car">Car</option>
              </select>
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Vehicle Number
                {vehicleType !== "Cycle" && <span className="required">*</span>}
              </label>

              <input
                className="form-control"
                placeholder={
                  vehicleType === "Cycle"
                    ? "Not required for Cycle"
                    : "Enter vehicle number (e.g. DL01AB1234)"
                }
                value={vehicleNumber}
                onChange={(e) => setVehicleNumber(e.target.value)}
                disabled={vehicleType === "Cycle"}
              />
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Driving License Number
                {vehicleType !== "Cycle" && <span className="required">*</span>}
              </label>

              <input
                className="form-control"
                placeholder={
                  vehicleType === "Cycle"
                    ? "Not required for Cycle"
                    : "Enter driving license number"
                }
                value={drivingLicenseNumber}
                onChange={(e) => setDrivingLicenseNumber(e.target.value)}
                disabled={vehicleType === "Cycle"}
              />
            </div>

          </div>
          <div className="col-md-6 pb-3 d-flex mt-2 align-items-end">
            <button className="btn btn-primary " disabled={loading}>
              {loading ? "Saving..." : editId ? "Update Delivery Partner" : "Save Delivery Partner"}
            </button>

            <button
              type="button"
              className="btn btn-secondary mx-2"
              onClick={() => {
                setShowMap(true);

                setTimeout(() => {
                  mapRef.current?.scrollIntoView({ behavior: "smooth" });
                }, 200);
              }}
            >
              Select Location From Map
            </button>
          </div>

        </form>

      </div>


      {/* MAP */}
      {showMap && (
        <div ref={mapRef} className="premium-card mb-4">


          <div className="vector-map-wrapper">
            <VectorMap
              provider="google"
              onConfirm={(data: any) => {

                setLatitude(data.latitude.toString());
                setLongitude(data.longitude.toString());
                setDigiPin(data.digiPin);
                setAddress(data.address);

                setShowMap(false);

              }}
            />
          </div>


        </div>
      )}

      {/* TABLE */}
      <div className="premium-card mt-3">

        <h5 className="mb-3">Delivery Partners List</h5>

        <DataTable
          columns={columns}
          data={partners}
          pagination
          highlightOnHover
          responsive

        />


      </div>

      {/* DELETE MODAL */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        dialogClassName="custom-top-modal"
      >
        <Modal.Body className="text-center pb-0 mt-1">
          <p className="fs-6">
            Are you sure you want to delete this delivery partner?
          </p>
        </Modal.Body>

        <Modal.Footer className="justify-content-center">
          <button
            type="button"
            className="btn py-2 px-3 btn-primary"
            onClick={handleDelete}
          >
            Yes
          </button>

          <button
            type="button"
            className="btn py-2 px-3 btn-secondary mx-2"
            onClick={() => setShowDeleteModal(false)}
          >
            No
          </button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};

export default AddDeliverypartner;